import React from 'react';
import SplitLayout from '../../common/layouts/splitLayout/SplitLayout';
import LimitsForm from './LimitsForm';
import AccessRulesCard from './accessRulesCard/AccessRulesCard';
import styles from './styles/limits-step.module.scss';

function LimitsStep({
    values,
    enabled,
    handlers,
    capRulePanels,
    capRuleTabs,
    accessRulesCardData,
    accessRulesReadOnly,
    loading,
    disabledSave,
    submitText,
    confirmBeforeSubmit,
    onSubmit,
    onCancel,
    readOnly,
}) {
    return (
        <SplitLayout
            className={styles.splitRoot}
            contentClassName={styles.splitContent}
            sideClassName={styles.splitSide}
            side={
                <AccessRulesCard
                    state={accessRulesCardData}
                    handlers={handlers}
                    readOnly={accessRulesReadOnly}
                />
            }
        >
            <LimitsForm
                values={values}
                enabled={enabled}
                handlers={handlers}
                capRulePanels={capRulePanels}
                capRuleTabs={capRuleTabs}
                loading={loading}
                disabledSave={disabledSave}
                submitText={submitText}
                confirmBeforeSubmit={confirmBeforeSubmit}
                onCancel={onCancel}
                onSubmit={onSubmit}
                readOnly={readOnly}
            />
        </SplitLayout>
    );
}

export default LimitsStep;
